import { render, staticRenderFns } from "./ContractPersonallyCertify.vue?vue&type=template&id=916a10aa&"
import script from "./ContractPersonallyCertify.vue?vue&type=script&lang=js&"
export * from "./ContractPersonallyCertify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports